import { useQuery } from '@tanstack/react-query'

import { VestingBalance } from '~/components/smart-accounts/vesting/types'
import { QUERY_KEYS } from '~/constants/react-query'
import { REFETCH_VESTING } from '~/constants/refetch-intervals'
import { useServerRequests } from '~/hooks/useRequests'
import { BackendTransactionCall } from '~/types'
import { EvmAddress } from '~/utils/address'

export const useCallsToClaim = (vestingBalance: VestingBalance) => {
  const { serverGetRequest } = useServerRequests()

  return useQuery<BackendTransactionCall[]>({
    queryKey: [QUERY_KEYS.VESTING_CALLS_TO_CLAIM, vestingBalance.id],
    enabled: !!vestingBalance.id,
    refetchInterval: REFETCH_VESTING,
    queryFn: async () => {
      const response = await serverGetRequest<{
        calls: { to: EvmAddress.Type; value: string; data: string }[]
      }>({
        path: `/api/vesting/claim/${vestingBalance.id}`,
      })

      if (!response) {
        throw new Error('Failed to fetch calls to claim')
      }

      return response.data.calls.map((call) => {
        return {
          to: call.to,
          value: BigInt(call.value),
          data: call.data,
        }
      })
    },
  })
}
